import { configureStore } from '@reduxjs/toolkit';
import authorsReducer from './authors';
import categoriesReducer from './categories';

export const store = configureStore({
  reducer: {
    authors: authorsReducer,
    categories: categoriesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
